import React from "react";
// import Breadcrumb from "../components/Breadcrumb";
import ContactMain from "../components/ContactMain";
import FooterOne from "../components/Footer/Footer";
import NavBar from "../components/Navbar/NavBar";

const Contact = () => {
  return (
    <>
      <NavBar />

      {/* <Breadcrumb title={"Contact"} /> */}

      <ContactMain />

      <FooterOne />
    </>
  );
};

export default Contact;
